"use client";
import Button from "@/components/Cards/Button";
import SmallVideoCard from "@/components/Cards/SmallVideoCard";
import MasterclassStats from "@/components/MasterclassStats";
import InfoModal from "@/components/Modal";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Text from "@/components/Text/Text";
import { LongButton } from "@/stories/Button.stories";
import type { Video } from "@/types";
import { formatDuration, getModuleVideosWithSub } from "@/utils";
import { useState } from "react";
import videos from "../../../../public/content/videos.json";
import Triangles from "@/components/Triangles";
import Newsletter from "@/components/Cards/Newsletter";
import { NewsletterYellowInput } from "@/stories/Newsletter.stories";
import Testimonial from "@/components/Text/Testimonial";
import { TestimonialBlue } from "@/stories/Testemonial.stories";
import Card from "@/components/Cards/Card";
import { CardIconSm } from "@/stories/Card.stories";
import SideBySideText from "@/components/Text/SideBySideText";
import { SBSTitleLeftTxtRight } from "@/stories/SideBySide.stories";
import Title from "@/components/Text/Title";

export default function AktuelleForschungenLayout() {
    const moduleVideosWithSub = getModuleVideosWithSub(
        videos,
        "Modul 2: Warum ist die Forschung entstanden?",
    );
    const [id, setId] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [openModalVideo, setOpenModalVideo] = useState(false);

    const iconCard = [
        {
            title: "Energiefeldsignatur",
            text: "Wie ein Fingerabdruck",
            img: "/images/cardIcon1.svg",
        },
        {
            title: "Reifeprozesse",
            text: "Energiefelder lernen durch Erfahrung",
            img: "/images/cardIcon2.svg",
        },
        {
            title: "Wie man Energiefelder stärkt?",
            text: "Fernbehandlung",
            img: "/images/cardIcon3.png",
        },
        {
            title: "Den Energiefeldern Raum geben",
            text: "Entwicklung ermöglichen",
            img: "/images/cardIcon4.png",
        },
        {
            title: "Energiefelder und ihre Aufgaben",
            text: "Erfahrung",
            img: "/images/cardIcon5.svg",
        },
        {
            title: "Wechselwirkung & Beeinflussung",
            text: "In ständigem Kontakt ",
            img: "/images/cardIcon6.svg",
        },
    ];
    return (
        <>
            <div className="bg-black flex ">
                <div className="container  w-full space-y-1 px-6 py-28  items-start flex-col justify-start md:items-center lg:justify-center  lg:items-center gap-5 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Dieser Frage bin ich auf der Spur"
                        title="Warum in aller Welt drückt man den roten Knopf?"
                        hasColorTitle={false}
                        hasSubTitle={false}
                        hasText={false}
                        wholeTitleAlignment="lg:text-center md:text-center text-left"
                        textColor="text-white"
                        paddings=" md:px-20"
                        preTitleStyle="font-bold"
                        preTitleSize=" text-2xl lg:text-xl3"
                        textAlignment=""
                    />
                    <PlayerInPage
                        videoId="ddf29d1b63cc402d909be3f32528b1a0"
                        thumbnail="/images/thumbnails/aktueleThumbnail.jpg"
                    />
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise w-full   space-y-1 px-6 py-10 md:px-5 lg:px-48 flex-col justify-center items-center gap-5 inline-flex">
                <SideBySideText
                    backgroundColor={SBSTitleLeftTxtRight.args?.backgroundColor}
                    elementLeft={SBSTitleLeftTxtRight.args?.elementLeft}
                    elementRight={SBSTitleLeftTxtRight.args?.elementRight}
                    hasSubTitle={SBSTitleLeftTxtRight.args?.hasSubTitle}
                    paddings="space-y-7 md:space-x-10"
                />
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white w-full space-y-1 px-9 md:px-5 lg:px-80 py-20 flex-col justify-center items-center gap-5 inline-flex">
                <div className="text-center text-black text-[40px] lg:text-[80px] font-bold  leading-[52px] lg:leading-[80px]">
                    Einblick in einige Forschungsfelder
                </div>
                <div className="text-center text-black   text-xl font-normal  leading-7">
                    Es ist mir ein Herzensprojekt, meine Forschungen zur
                    Energiefeldmechanik zu teilen. Hier nur einige Themen, über die ich
                    in Zukunft sprechen werde.{" "}
                </div>
                <div className="lg:grid grid-cols-3 md:gap-2  gap-7 text-center space-y-5 lg:space-y-0">
                    {iconCard.map((card) => (
                        <div key={card.title}>
                            <Card
                                height={CardIconSm.args?.height}
                                width={CardIconSm.args?.width}
                                hasButton={CardIconSm.args?.hasButton}
                                hasImage={CardIconSm.args?.hasImage}
                                hasList={CardIconSm.args?.hasList}
                                hasPretitle={CardIconSm.args?.hasPretitle}
                                hasText={CardIconSm.args?.hasText}
                                imageSize={CardIconSm.args?.imageSize}
                                textSize={CardIconSm.args?.textSize}
                                contentSize={CardIconSm.args?.contentSize}
                                titleSize={"text-2xl font-bold text-center"}
                                leadings="leading-6"
                                titlePlacement="center"
                                imgSrc={card.img}
                                title={card.title}
                                content={card.text}
                                backgroundColor="bg-white"
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-blue" buttomToTop={false} />
            </div>
            <div className="bg-blue flex justify-center">
                <div className="container w-full space-y-1 px-3 flex-col justify-center items-center gap-5 inline-flex">
                    <Testimonial
                        backgroundColor={TestimonialBlue.args?.backgroundColor}
                        description={TestimonialBlue.args?.description}
                        differentTextColor={"text-lightYellow"}
                        hasDescription={TestimonialBlue.args?.hasDescription}
                        hasImage={TestimonialBlue.args?.hasImage}
                        icon={TestimonialBlue.args?.icon}
                        name={TestimonialBlue.args?.name}
                        text="Menschen sind widerstandsfähig und belastbar, wenn ihr Energiefeld funktioniert."
                        textColor={TestimonialBlue.args?.textColor}
                        textSizes={TestimonialBlue.args?.textSizes}
                        wordsInDifferentColor={[
                            "widerstandsfähig",
                            "belastbar,",
                            "Energiefeld",
                            "funktioniert.",
                        ]}
                    />
                </div>
            </div>
            <div className="bg-blue">
                <Triangles backgroundColor="bg-pink" buttomToTop={true} />
            </div>
            <div className="bg-pink flex justify-center">
                <div className="container w-full  px-3  py-20 flex-col gap-6 inline-flex">
                    <div className="flex justify-center items-center">
                        <Text
                            title="Jetzt mehr erfahren zu meiner Forschung"
                            paddings="lg:px-0"
                            paragraphs={[
                                "Erfahre in den Kurzvideos mehr darüber, woran ich aktuell forsche und warum es für mich ein absolutes Muss war, die Mechanismen und Gegensätze der Energiefelder zu hinterfragen.",
                            ]}
                            hasSubTitle={false}
                            titleSize="text-[40px] lg:5xl"
                            leading="leading-[52px] lg:leading-14"
                            leadingText="lg:leading-8.5 leading-7"
                        />
                    </div>

                    <div className="">
                        <MasterclassStats
                            videos_duration="4 hrs 50 min"
                            module_count="5"
                            videos_count="150"
                            buttonColor="bg-white"
                            buttonTextColor="text-pink"
                        />
                    </div>
                    <InfoModal
                        onClose={() => setOpenModalVideo(false)}
                        opened={openModalVideo}
                        size="full"
                        paddings="lg:px-5 lg:pb-7 px-0"
                        fullScreen={false}
                    >
                        <PlayerInPage videoId={id} thumbnail={thumbnail} />
                    </InfoModal>
                    <p className="lg:text-xl1 text-lg font-normal leading-8.5 md:leading-7  ">
                        Schau dir 8 Videos aus der Masterclass an. Lust auf mehr? Dann
                        klicke unten auf den Button und tauche tiefer in die Masterclass
                        ein.
                    </p>
                    <div className="lg:grid md:grid md:grid-cols-3 gap-6 grid-cols-4">
                        {moduleVideosWithSub?.slice(0, 8).map((video: Video) => {
                            return (
                                <div key={video.id}>
                                    <button
                                        type="button"
                                        className="curor-pointer text-left"
                                        onClick={() => {
                                            setId(video.id);
                                            setThumbnail(video.thumbnail);
                                            setOpenModalVideo(true);
                                        }}
                                    >
                                        <SmallVideoCard
                                            img={video.thumbnail}
                                            duration={formatDuration(video.duration)}
                                            free={true}
                                            title={video.title}
                                        />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                    <div className="flex mx-auto justify-center">
                        <Button
                            backgroundColor={LongButton.args?.backgroundColor}
                            border={LongButton.args?.border}
                            hasIcon={LongButton.args?.hasIcon}
                            textSize={LongButton.args?.textSize}
                            textColor={LongButton.args?.textColor}
                            size={LongButton.args?.size}
                            paddings={LongButton.args?.paddings}
                            rounded={LongButton.args?.rounded}
                            text="Ich WILL MEHR DAVON SEHEN"
                            as="a"
                            href="/de/masterclass#masterclassSection"
                        />
                    </div>
                </div>
            </div>
            <div className="bg-pink">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full  px-6 lg:px-20  flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterYellowInput.args?.backgroundColor}
                        hasCheckbox={false}
                        hasDescription={NewsletterYellowInput.args?.hasDescription}
                        hasInput={NewsletterYellowInput.args?.hasInput}
                        hasSubText={true}
                        buttonText="Absenden und up do date bleiben"
                        title="Rico’s News abonnieren "
                        checkBoxText="Allgemeine Geschäftsbedingungen und Datenschutzbestimmungen gelesen und akzeptiere sie."
                        inputText="Deine E-Mail-Adresse"
                        hasForm={true}
                        subText="Die Abmeldung vom Newsletter ist jederzeit möglich."
                        buttonPaddings="lg:py-4 md:py-4 md:px-16 py-4 px-1 lg:px-16"
                        paddings="lg:px-96 md:px-20 "
                        newsletterForm={true}
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
